import { useState } from "react";
import { Card, Title } from "@tremor/react";
import { Button, Empty, Input, Typography } from "antd";
import dayjs from "dayjs";

import { CollectionsEventKind, type CollectionsEvent } from "@fitness-app/data-models/entities/CollectionsCase";

interface CaseNotesProps {
  events: CollectionsEvent[];
  saving: boolean;
  onAdd: (note: string, done: () => void) => void;
}

/** Free-form notes on the case, newest first: what the client said, what was agreed, what to remember. */
const CaseNotes = ({ events, saving, onAdd }: CaseNotesProps) => {
  const [draft, setDraft] = useState("");
  const notes = events.filter((event) => event.kind === CollectionsEventKind.Note);
  const submit = () => {
    const note = draft.trim();
    if (!note) return;
    onAdd(note, () => setDraft(""));
  };

  return (
    <Card>
      <Title>Notatki</Title>
      <div className="mt-3 flex flex-col gap-2">
        <Input.TextArea
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          autoSize={{ minRows: 2, maxRows: 6 }}
          placeholder="Co ustaliłaś, co klientka powiedziała, o czym pamiętać przy następnym kontakcie"
          onKeyDown={(event) => {
            if ((event.metaKey || event.ctrlKey) && event.key === "Enter") submit();
          }}
        />
        <div className="flex justify-end">
          <Button type="primary" onClick={submit} loading={saving} disabled={!draft.trim()}>
            Dodaj notatkę
          </Button>
        </div>
      </div>
      <div className="mt-4 flex flex-col gap-3">
        {notes.length ? (
          notes.map((event) => (
            <div key={event.id} className="border-l-2 border-gray-200 pl-3">
              <Typography.Text type="secondary" className="text-xs">
                {dayjs(event.occurredAt).format("DD.MM.YYYY HH:mm")}
              </Typography.Text>
              <Typography.Paragraph className="mb-0 whitespace-pre-wrap text-sm">
                {String(event.payload.note ?? "")}
              </Typography.Paragraph>
            </div>
          ))
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Brak notatek" className="py-2" />
        )}
      </div>
    </Card>
  );
};

export default CaseNotes;
